import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { JsonLd } from 'react-schemaorg';
import LazyHydrate from 'react-lazy-hydration';
import { isMobileSafari } from 'react-device-detect';
import Fullscreen from 'react-full-screen';
import scrollToComponent from 'react-scroll-to-component-ssr';
import get from 'lodash/get';
import map from 'lodash/map';
import replace from 'lodash/replace';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import absoluteUrl from 'helpers/absoluteUrl';
import AskQuestion, { TelegramPhone, ViberPhone } from 'subsys/ask-question';
import { Maps, BaseLayersUser, InfoLayer, FullscreenControl } from 'containers/maps';
import Link from 'components/link';
import Button from 'components/button';
import AdSense from 'components/adsense';
import Row, { Col } from 'components/row';
import Icon, { iconTypes } from 'components/icon';
import TabJSControl from 'components/tab-js-control';
import Image, { Thumb, OpenGraphImage } from 'components/image';

import { getImages } from 'src-sites/domik/section-project/get-images';

import { renderBlockStocks, renderPurchaseOptions } from './content-project';
import { renderJsonLd, getRoute } from './render-common';
import marker from '../assets/map-marker';

import translates from './project-i18n';

import 'styles/domik/section-project/_page-project-contacts.scss';

const bemClassesProject = new Bem('project');

@I18nHoc(translates())
export default class ContentContacts extends Component {
  static propTypes = {
    params: PropTypes.shape({}),
    project: PropTypes.shape({
      advanced_info: PropTypes.shape({})
    }),
    preloadedContacts: PropTypes.shape({}),
    mainDeveloperData: PropTypes.shape({}),
    contentBlocks: PropTypes.shape({}),
    seoData: PropTypes.shape({}),
    topic: PropTypes.string
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.state = {
      isFullScreenMode: false
    };
  }

  handleScreenClick =()=> {
    this.setState({ isFullScreenMode: !(this.state.isFullScreenMode) });
  }

  renderBtnToAskQuestion =()=> {
    const { i18n } = this;

    return (
      <Button
        {...bemClassesProject('btn', 'toAskQuestion')}
        onClick={this.scrollToAskQuestion}
        label={i18n('btnToAskQuestionText')}
        title={i18n('btnToAskQuestionText')}
        // iconType={iconTypes.comment}
        // contentLeft
      />
    );
  }

  renderInfoContacts =(contacts, project)=> {
    const { i18n } = this;
    const { phones = [], info } = contacts;
    const projectId = get(project, 'id');
    const name = get(contacts, 'name') || i18n('connectConsult');
    const imageId = get(project, 'title_image.id');
    const dataJsonLdImg = {
      name: name || null,
      description: name || null,
      contentUrl: imageId ? absoluteUrl(`/images/orig/full/${imageId}`) : null
    };
    const viberPhone = get(info, 'sn.viber');
    const telegramUrl = get(info, 'sn.telegram');
    const email = get(info, 'contact_email');
    let scheduleStandard = null;
    let scheduleNonStandard = null;
    let scheduleNonStandard_2 = null;
    let daysOff = null;

    if (get(info, 'start_week') || get(info, 'end_week') || get(info, 'start_time') || get(info, 'end_time')) {
      const week = (
        get(info, 'start_week') || get(info, 'end_week') ?
        <span
          {...bemClassesProject('week')}
          children={`${get(info, 'start_week') || ''}${get(info, 'start_week') && get(info, 'end_week') ? ' - ' : ''}${get(info, 'end_week') || ''}`}
        /> :
        null
      );
      const time = (
        get(info, 'start_time') || get(info, 'end_time') ?
        <span
          {...bemClassesProject('time')}
          children={`${get(info, 'start_time') || ''}${get(info, 'start_time') && get(info, 'end_time') ? ' - ' : ''}${get(info, 'end_time') || ''}`}
        /> :
        null
      );
      scheduleStandard = (
        <>
          {/*
          <div {...bemClassesProject('text', 'label')} children={i18n('scheduleStandard')} />
          */}
          <div {...bemClassesProject('text')}>
            <Icon {...bemClassesProject('icon', 'schedule')} type={iconTypes.clock} />
            {week}
            {time}
          </div>
        </>
      );
    }
    if (get(info, 'no_standard_start_week') || get(info, 'no_standard_end_week') || get(info, 'no_standard_start_time') || get(info, 'no_standard_end_time')) {
      const week = (
        get(info, 'no_standard_start_week') || get(info, 'no_standard_end_week') ?
        <span
          {...bemClassesProject('week')}
          children={`${get(info, 'no_standard_start_week') || ''}${get(info, 'no_standard_start_week') && get(info, 'no_standard_end_week') ? ' - ' : ''}${get(info, 'no_standard_end_week') || ''}`}
        /> :
        null
      );
      const time = (
        get(info, 'no_standard_start_time') || get(info, 'no_standard_end_time') ?
        <span
          {...bemClassesProject('time')}
          children={`${get(info, 'no_standard_start_time') || ''}${get(info, 'no_standard_start_time') && get(info, 'no_standard_end_time') ? ' - ' : ''}${get(info, 'no_standard_end_time') || ''}`}
        /> :
        null
      );
      scheduleNonStandard = (
        <>
          {/*
          <div {...bemClassesProject('text', 'label')} children={i18n('scheduleNonStandard')} />
          */}
          <div {...bemClassesProject('text')}>
            <Icon {...bemClassesProject('icon', 'schedule')} type={iconTypes.clock} />
            {week}
            {time}
          </div>
        </>
      );
    }
    if (get(info, 'no_standard_start_week_2') || get(info, 'no_standard_end_week_2') || get(info, 'no_standard_start_time_2') || get(info, 'no_standard_end_time_2')) {
      const week = (
        get(info, 'no_standard_start_week_2') || get(info, 'no_standard_end_week_2') ?
        <span
          {...bemClassesProject('week')}
          children={`${get(info, 'no_standard_start_week_2') || ''}${get(info, 'no_standard_start_week_2') && get(info, 'no_standard_end_week_2') ? ' - ' : ''}${get(info, 'no_standard_end_week_2') || ''}`}
        /> :
        null
      );
      const time = (
        get(info, 'no_standard_start_time_2') || get(info, 'no_standard_end_time_2') ?
        <span
          {...bemClassesProject('time')}
          children={`${get(info, 'no_standard_start_time_2') || ''}${get(info, 'no_standard_start_time_2') && get(info, 'no_standard_end_time_2') ? ' - ' : ''}${get(info, 'no_standard_end_time_2') || ''}`}
        /> :
        null
      );
      scheduleNonStandard_2 = (
        <>
          <div {...bemClassesProject('text')}>
            <Icon {...bemClassesProject('icon', 'schedule')} type={iconTypes.clock} />
            {week}
            {time}
          </div>
        </>
      );
    }
    if (get(info, 'day_off_1') || get(info, 'day_off_2')) {
      const week = (
        <span
          {...bemClassesProject('week')}
          children={`${get(info, 'day_off_1') || ''}${get(info, 'day_off_1') && get(info, 'day_off_2') ? ', ' : ''}${get(info, 'day_off_2') || ''}`}
        />
      );
      daysOff = (
        <>
          <div {...bemClassesProject('text', 'label')} children={i18n('dayOff')} />
          <div {...bemClassesProject('text')}>
            <Icon {...bemClassesProject('icon', 'schedule')} type={iconTypes.clock} />
            {week}
          </div>
        </>
      );
    }

    return (
      <Row {...bemClassesProject('blockContactsInfo')} mpColumn>
        <Col {...bemClassesProject('col', 'img')} mdAuto allPr={0}>
          <div {...bemClassesProject('imgContainer')}>
            <div {...bemClassesProject('img')}>
              <Image
                {...bemClassesProject('imgPic')}
                image={getImages.call(this, imageId, { alt: name, title: name }).titleImage}
              />
              {renderJsonLd('ImageObject', dataJsonLdImg)}
            </div>
          </div>
        </Col>
        <Col {...bemClassesProject('col', 'info')} allPr={0}>
          <div {...bemClassesProject('contactsInfo')}>
            <div {...bemClassesProject('text', 'name')} children={name} />
            {phones && !!phones.length && map(phones, (phone, key) => (
              <div key={key} {...bemClassesProject('phone')}>
                <Link
                  {...bemClassesProject('link', 'phone')}
                  href={`tel:${replace(phone, /[\s\(\)]/g, '')}`}
                  external
                >
                  <span {...bemClassesProject('linkContent')}>
                    <Icon {...bemClassesProject('icon', 'phone')} type={iconTypes.phoneCallsBorder} />
                    <span {...bemClassesProject('text')} children={phone} />
                  </span>
                </Link>
              </div>
            ))}
            {/*!!email &&
            <div {...bemClassesProject('mail')}>
              <Link
                {...bemClassesProject('link', 'mail')}
                href={`mailto:${email}`}
                title={email}
                external
              >
                <span {...bemClassesProject('linkContent')}>
                  <Icon {...bemClassesProject('icon', 'email')} type={iconTypes.letterBorderLighter} />
                  <span {...bemClassesProject('text', 'underline')} children={email} />
                </span>
              </Link>
            </div>
            */}
            {!!get(info, 'address') &&
              <div {...bemClassesProject('text')}>
                <Icon {...bemClassesProject('icon', 'address')} type={iconTypes.markerBorderLighter} />
                {get(info, 'address')}
              </div>
            }
            {(
              (get(info, 'start_week') || get(info, 'end_week') || get(info, 'start_time') || get(info, 'end_time')) ||
              (get(info, 'no_standard_start_week') || get(info, 'no_standard_end_week') || get(info, 'no_standard_start_time') || get(info, 'no_standard_end_time')) ||
              (get(info, 'no_standard_start_week_2') || get(info, 'no_standard_end_week_2') || get(info, 'no_standard_start_time_2') || get(info, 'no_standard_end_time_2')) ||
              (get(info, 'day_off_1') || get(info, 'day_off_2'))
            ) &&
              <div {...bemClassesProject('text', 'label')} children={i18n('scheduleWork')} />
            }
            {scheduleStandard}
            {scheduleNonStandard}
            {scheduleNonStandard_2}
            {daysOff}
            {!!get(info, 'no_standard_description') &&
              <div {...bemClassesProject('text')}>
                {get(info, 'no_standard_description')}
              </div>
            }
            {!!get(info, 'note_working_hours') &&
              <>
                <div {...bemClassesProject('text', 'label')} children={i18n('scheduleNonStandardNote')} />
                <div {...bemClassesProject('text')} children={get(info, 'note_working_hours')} />
              </>
            }
            {!get(info, 'note_working_hours') &&
              <div {...bemClassesProject('text')} children={i18n('scheduleCanBeChanged')} />
            }
            {(viberPhone || telegramUrl || !!email) &&
              <div {...bemClassesProject('socials')}>
                {viberPhone &&
                  <ViberPhone
                    device="desktop"
                    phone={viberPhone}
                    projectId={projectId}
                    developerId={+get(info, 'parent')}
                  />
                }
                {telegramUrl &&
                  <TelegramPhone
                    device="tablet"
                    phone={telegramUrl}
                    projectId={projectId}
                    developerId={+get(info, 'parent')}
                  />
                }
                {!!email && this.renderBtnToAskQuestion()}
              </div>
            }
          </div>
        </Col>
      </Row>
    );
  }

  renderMapContacts =()=> {
    const { i18n } = this;
    const { preloadedContacts, mainDeveloperData } = this.props;
    const contacts = get(preloadedContacts, 'complexContacts.data[0]', {});
    const { isFullScreenMode } = this.state;
    const { geo, info } = contacts;
    const name = get(contacts, 'name') || i18n('connectConsult');
    const email = get(info, 'contact_email');
    const avatar = get(mainDeveloperData, 'avatar');
    const image = (typeof avatar === 'string' || !avatar) ? { id: avatar } : avatar;
    const avatarDeveloper = { ...image, alt: name, title: name };
    const dataJsonLdImg = {
      name: get(avatarDeveloper, 'alt', null),
      description: get(avatarDeveloper, 'title', null),
      contentUrl: get(image, 'id') ? absoluteUrl(`/images/thumb/full/${image.id}`) : null
    };

    return (
      <div {...bemClassesProject('blockMap')} ref={ref => this.refBlockMap = ref}>
        <div {...bemClassesProject('mapContainer')}>
          <Fullscreen
            enabled={isFullScreenMode}
            onChange={
              isFullScreen => this.setState({
                isFullScreenMode: isFullScreen
              })
            }
          >
            <Maps
              {...bemClassesProject('map')}
              noAutoGeolocate
              adaptiveScrollZoom={2000}
              maxZoom={17}
            >
              <BaseLayersUser key="bl" />
              {!isMobileSafari &&
                <FullscreenControl
                  key="fs"
                  isFullscreen={isFullScreenMode}
                  onScreenIconClick={this.handleScreenClick}
                  position="topleft"
                />
              }
              {geo &&
                <>
                  <InfoLayer
                    key="gc"
                    noAutoFit
                    data={[geo]}
                    maxZoom={18}
                    markerProps={{ icon: marker() }}
                  />
                  <InfoLayer
                    fitMaxZoom={17}
                    minZoom={19}
                    key="il"
                    data={[geo]}
                  />
                </>
              }
            </Maps>
            {getRoute.call(this, geo, bemClassesProject)}
          </Fullscreen>
          <div {...bemClassesProject('mapBesideMarker')}>
            <div {...bemClassesProject('imgContainer')}>
              <div {...bemClassesProject('img')}>
                <Thumb
                  {...bemClassesProject('imgPic')}
                  image={avatarDeveloper}
                />
                {renderJsonLd('ImageObject', dataJsonLdImg)}
              </div>
            </div>
            <div {...bemClassesProject('text', 'name')} children={name} />
            {!!email && this.renderBtnToAskQuestion()}
          </div>
        </div>
      </div>
    );
  }

  renderDrivings =(info, displayName)=> {
    const { i18n } = this;
    const imageArr = get(info, 'driving_directions');

    if (!imageArr || !imageArr.length) return null;

    const tabs = map(imageArr, (imgId, key) => {
      if (!imgId) return null;

      const topic = i18n('driveway', { placeholder: key + 1 });
      const alt = `${topic}, ${displayName}`;
      const dataJsonLdImg = {
        name: alt || null,
        description: topic || null,
        contentUrl: imgId ? absoluteUrl(`/images/orig/full/${imgId}`) : null
      };

      return (
        <tab title={topic}>
          <div {...bemClassesProject('imgContainer')}>
            <div {...bemClassesProject('img')}>
              <Image
                {...bemClassesProject('imgPic')}
                image={getImages.call(this, imgId, { alt, title: topic }).titleImage}
                group="projectDrivings"
              />
              {renderJsonLd('ImageObject', dataJsonLdImg)}
            </div>
          </div>
        </tab>
      );
    });

    return (
      <div {...bemClassesProject('blockContactsDriving')}>
        <TabJSControl
          {...bemClassesProject('tabs')}
          aside={
            <Row {...bemClassesProject('rowTopic')}>
              <Col allPr={0}><div {...bemClassesProject('text', 'h2')}><h2 children={i18n('drivingDirectionsH2')} /></div></Col>
            </Row>
          }
          children={tabs}
        />
      </div>
    );
  }

  renderAwards =(images, displayName)=> {
    if (!images || !images.length) return null;

    const { i18n } = this;

    const imagesAwards = map(images, (item, key) => {
      const topic = item.title || '';
      const alt = `${topic}, ${displayName}`;
      const dataJsonLdImg = {
        name: alt || null,
        description: topic || null,
        contentUrl: item.image ? absoluteUrl(`/images/orig/full/${item.image}`) : null
      };

      return (
        <Col key={key} {...bemClassesProject('award')} allAuto allPr={0}>
          <div {...bemClassesProject('imgContainer')}>
            <div {...bemClassesProject('img')}>
              <Image
                {...bemClassesProject('imgPic')}
                image={getImages.call(this, item.image, { alt, title: topic }).titleImage}
                group="projectAwards"
              />
              {renderJsonLd('ImageObject', dataJsonLdImg)}
            </div>
            {/*
            <div
              {...bemClassesProject('text', 'caption')}
              children={topic}
            />
            */}
          </div>
        </Col>
      );
    });

    return (
      <div {...bemClassesProject('blockContactsAwards')}>
        <Row {...bemClassesProject('rowTopic')}>
          <Col allPr={0}><div {...bemClassesProject('text', 'h2')}><h2 children={i18n('awardsH2')} /></div></Col>
        </Row>
        <Row {...bemClassesProject('awards')} children={imagesAwards} />
      </div>
    );
  }

  scrollToAskQuestion =()=> {
    this.scrollToRef(this.askQuestionRef);
  }

  scrollToRef =(ref)=> {
    scrollToComponent(ref, { offset: -70, align: 'top', duration: 700, ease: 'linear' });
  }

  render() {
    const { i18n } = this;
    const {
      project = {}, preloadedContacts, params, topic, contentBlocks, mainDeveloperData
    } = this.props;
    const contacts = get(preloadedContacts, 'complexContacts.data[0]', {});
    const { parent_portfolio = [], phones = [], info: infoContacts, geo: geoContacts } = contacts;
    const name = get(contacts, 'name') || i18n('connectConsult');
    const projectId = get(project, 'id');
    const url = get(project, 'url');
    const imageId = get(project, 'title_image.id');
    const {
      advanced_info = {}, display_path, location_path, title_image, status_ready, ...rest
    } = project;
    const propsGroup = { ...advanced_info, ...rest, title_image };
    const emailContacts = get(infoContacts, 'contact_email');
    const addressContacts = get(infoContacts, 'address');

    // console.log('lolo', infoContacts);
    // console.log('lolo', infoContacts.start_week, infoContacts.end_week);
    // let arrWeek = [];
    // let arrWeekSeo = [];
    // if (infoContacts.start_week && infoContacts.end_week) {
    //   arrWeek = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
    //   arrWeekSeo = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    // }

    return (
      <>
        <LazyHydrate ssrOnly>
          <OpenGraphImage imageId={imageId} />
        </LazyHydrate>
        <div {...bemClassesProject('title')}>
          <div {...bemClassesProject('text')}><h1 children={topic} /></div>
        </div>
        {this.renderInfoContacts(contacts, project)}
        {this.renderMapContacts()}
        <LazyHydrate whenVisible>
          {this.renderDrivings(infoContacts)}
        </LazyHydrate>
        <LazyHydrate whenVisible>
          <Row {...bemClassesProject('row', 'purchaseOptionsRow')}>
            {renderPurchaseOptions.call(this, propsGroup)}
            {renderBlockStocks.call(this, rest.stocks_array, propsGroup)}
          </Row>
        </LazyHydrate>
        <AdSense {...bemClassesProject('blockAdSense')} />
        {!!emailContacts &&
          <>
            <Row {...bemClassesProject('rowTopic')}>
              <Col allPr={0}><div {...bemClassesProject('text', 'h2')}><h2 children={i18n('askQuestionTopic')} /></div></Col>
            </Row>
            <AskQuestion
              {...bemClassesProject('blockAskQuestion')}
              controller="support/ask-question/ask-developer-question"
              ref={ref => this.askQuestionRef = ref}
              entityId={projectId}
              entity="ask_question"
              url={get(params, 'url')}
              otherProps={{
                notificationMessageSuccess: i18n('askQuestionMessage'),
                inputPhoneProps: { noLabel: true, noElementBefore: true },
                additionalMain: false,
                headerTopic: true,
                headerTopicText: name,
                firstSeller: mainDeveloperData,
                hideTelephoneBtnIconType: iconTypes.phoneMob,
                free_taxi: get(project, 'free_taxi'),
                marker,
                counterProps: {
                  action: 'askDeveloperQuestion',
                  entity: {
                    project_id: projectId
                  }
                }
              }}
            />
          </>
        }
        {this.renderAwards(parent_portfolio, project.display_name)}
        {contentBlocks}
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name,
            url: absoluteUrl(url),
            image: imageId ? absoluteUrl(`/images/thumb/full/${imageId}`) : null,
            contactPoint: [
              {
                '@type': 'ContactPoint',
                name,
                image: imageId ? absoluteUrl(`/images/thumb/full/${imageId}`) : null,
                url: absoluteUrl(url),
                contactType: 'customer service',
                telephone: (phones && !!phones.length) ? phones : null,
                address: addressContacts,
                areaServed: [
                  'UA',
                  {
                    '@type': 'Place',
                    geo: get(geoContacts, 'type') === 'Point' ? {
                      '@type': 'GeoCoordinates',
                      latitude: geoContacts.coordinates[1],
                      longitude: geoContacts.coordinates[0]
                    } : null
                  }
                ],
                /* TODO: надо придумать как передать график работы, чтоб он был понятен боту
                hoursAvailable: [
                  {
                    closes: '18:00:00',
                    dayOfWeek: 'https://schema.org/Monday',
                    opens: '09:00:00'
                  }, {
                    closes: '18:00:00',
                    dayOfWeek: 'https://schema.org/Tuesday',
                    opens: '09:00:00'
                  }, {
                    closes: '18:00:00',
                    dayOfWeek: 'https://schema.org/Wednesday',
                    opens: '09:00:00'
                  }, {
                    closes: '18:00:00',
                    dayOfWeek: 'https://schema.org/Thursday',
                    opens: '09:00:00'
                  }, {
                    closes: '18:00:00',
                    dayOfWeek: 'https://schema.org/Friday',
                    opens: '09:00:00'
                  }
                ]
                */
              }
            ]
          }}
        />
      </>
    );
  }
}
